import React, { useState } from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Popover,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
} from "@mui/material";
import {
  Home,
  Map,
  Brightness4,
  Brightness7,
  Info,
  Tune,
  CatchingPokemon,
  Person,
  MoreHoriz,
  Groups,
  WorkspacePremium,
  Code,
  Logout,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";

const BottomNav = ({ toggleTheme, themeMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = !!localStorage.getItem("token");

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const getTabValue = () => {
    const path = location.pathname;
    if (path === "/" || path === "/start") return "start";
    if (path.startsWith("/profile")) return "profile";
    if (path === "/login" || path === "/registration") return "login";
    if (path === "/pokedex") return "pokedex";
    if (path === "/arenamap") return "map";
    return null;
  };

  const handleNavigation = (event, value) => {
    if (value === "start") navigate("/");
    else if (value === "profile") navigate("/profile");
    else if (value === "login") navigate("/login");
    else if (value === "pokedex") navigate("/pokedex");
    else if (value === "map") navigate("/arenamap");
    else if (value === "more") setAnchorEl(event.currentTarget);
  };

  const close = () => setAnchorEl(null);

  const menuItem = (icon, label, onClick) => (
    <ListItem
      button
      onClick={() => { onClick(); close(); }}
      sx={{ cursor: "pointer", py: 1 }}
    >
      <ListItemIcon sx={{ minWidth: 36 }}>{icon}</ListItemIcon>
      <ListItemText primary={label} />
    </ListItem>
  );

  return (
    <>
      <Paper
        elevation={4}
        sx={{
          position: "fixed",
          bottom: 12,
          left: "50%",
          transform: "translateX(-50%)",
          width: { xs: "94%", sm: "80%", md: "60%" },
          maxWidth: 560,
          borderRadius: "24px",
          zIndex: 10,
          overflow: "hidden",
          bgcolor: "background.paper",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <BottomNavigation
          value={getTabValue()}
          onChange={handleNavigation}
          showLabels
          sx={{ bgcolor: "transparent", height: 60 }}
        >
          {isLoggedIn ? (
            <BottomNavigationAction label="Profil" value="profile" icon={<Person />} />
          ) : (
            <BottomNavigationAction label="Start" value="start" icon={<Home />} />
          )}

          {!isLoggedIn && (
            <BottomNavigationAction label="Login" value="login" icon={<Person />} />
          )}
          {isLoggedIn && (
            <BottomNavigationAction label="Pokédex" value="pokedex" icon={<CatchingPokemon />} />
          )}
          {isLoggedIn && (
            <BottomNavigationAction label="Arenen" value="map" icon={<Map />} />
          )}
          <BottomNavigationAction label="Mehr" value="more" icon={<MoreHoriz />} />
        </BottomNavigation>
      </Paper>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={close}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: "16px",
              mb: 0.5,
              boxShadow: 6,
              border: "1px solid",
              borderColor: "divider",
              minWidth: 200,
              bgcolor: "background.paper",
              overflow: "hidden",
            },
          },
        }}
      >
        <List dense disablePadding>
          {menuItem(
            themeMode === "light" ? <Brightness4 /> : <Brightness7 />,
            themeMode === "light" ? "Dark Mode" : "Light Mode",
            toggleTheme
          )}

          <Divider />

          {isLoggedIn &&
            menuItem(<Groups />, "Mitglieder", () => navigate("/members"))}
          {menuItem(<Code />, "Trainercodes", () => navigate("/trainercodes"))}
          {isLoggedIn &&
            menuItem(<WorkspacePremium />, "Medaillen", () => navigate("/medals"))}
          {isLoggedIn &&
            menuItem(<Tune />, "Einstellungen", () => navigate("/settings"))}
          {menuItem(<Info />, "Über die App", () => navigate("/about"))}

          {isLoggedIn && (
            <>
              <Divider />
              <ListItem
                button
                onClick={() => {
                  localStorage.removeItem("token");
                  window.location.href = "/";
                }}
                sx={{ cursor: "pointer", py: 1 }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <Logout color="error" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography color="error" fontWeight={600}>
                      Logout
                    </Typography>
                  }
                />
              </ListItem>
            </>
          )}
        </List>
      </Popover>
    </>
  );
};

export default BottomNav;
